import { Component, Inject, Input } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { TimezoneDTO } from 'src/app/api/models/timezone-dto';
import { ManagementService } from 'src/app/api/services';
import { SharedService } from 'src/app/services/shared.service';

@Component({
  selector: 'app-timezone-dialog',
  templateUrl: './timezone-dialog.component.html',
  styleUrls: ['./timezone-dialog.component.scss']
})
export class TimezoneDialogComponent {

  timeZones: TimezoneDTO[] = [];
  timeZone: string = "";
  loading: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<TimezoneDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    public managementService: ManagementService,
    public sharedService: SharedService,
    public translateService: TranslateService
  ) {
    this.timeZones = this.dialogData.timeZones;
  }

  onChange(timeZone: any) {
    this.timeZone = timeZone.value;
  }

  updateTimezone() {
    this.loading = true;
    this.managementService.updateTimezone(this.dialogData.idEvent, this.timeZone).subscribe(
      res => {
        this.dialogRef.close(this.timeZone)
        this.loading = false;
      },
      err => {
        this.loading = false;
        this.sharedService.openSnackBar(
          this.translateService.instant('ERROR_GENERIC_RETRY'),
          true);
      }
    )
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

}
